import React from "react";
import SaveChangesButton from "components/subscription-cart/save-changes";
import { useSelector } from "react-redux";
import useReactivationFlow from "hooks/useReactivationFlow";
import { useGlobalContext } from "context/global";

const ConfirmMealsButton = ({ callback }) => {
	const { draftChanges } = useSelector(state => state.account.subscription);
	const { updateReactivationFlow } = useReactivationFlow();
	const { translation } = useGlobalContext();

	const handleConfirm = () => {
		updateReactivationFlow({ step: 3 });
		if (callback) {
			callback();
		}
	};

	if (!draftChanges.unsaved) {
		return (
			<button className="text-small py-3 text-center px-10 btn-orange w-11/12 lg:w-auto my-2"
				onClick={handleConfirm}>
				{translation.other?.confirm_and_continue}
			</button>
		);
	}

	return (
		<div className="flex flex-col text-center w-11/12 lg:w-auto">
			<SaveChangesButton
				className="px-10 !btn-orange"
				onSuccess={handleConfirm}
				customText={translation.other?.confirm_and_continue}
			/>
		</div>
	);
};
export default ConfirmMealsButton;